import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { measure } from 'constants/units';

import { Input } from 'components/library';

import * as S from './styled';

import { FormikInputType } from 'types/ui';

const { TALL_UNIT } = measure;

const FormikInput = ({
    values,
    errors,
    initialValues,
    setFieldTouched,
    setFieldValue,
    touched,
    field,
    type = 'text',
    label,
    unit,
    className,
    leftIcon,
    innerRef,
    rightIcon,
    dataLocator,
    placeholder,
    mb,
    onInputFocus,
}: FormikInputType) => {
    const [isFocus, setIsFocus] = useState(false);
    const [isTouchedLocal, setIsTouchedLocal] = useState(false);

    useEffect(() => {
        if (initialValues[field] === values[field]) {
            setIsTouchedLocal(false);
        }
    }, [initialValues[field]]);

    const { t } = useTranslation();

    const errorStatus = !isFocus && Boolean(errors[field] && touched[field]);

    const withoutInchLabel = unit === TALL_UNIT.imperial.in ? '' : t(label || field);

    const handleFocus = () => {
        onInputFocus?.();

        setIsFocus(true);
        setIsTouchedLocal(false);
    };

    return (
        <S.StyledWrapper $mb={mb}>
            <Input
                label={withoutInchLabel}
                name={field}
                type={type}
                value={`${values[field]}`}
                unit={unit}
                placeholder={placeholder && t(placeholder)}
                errorMessage={t(errors[field] || '')}
                initialValue={`${initialValues[field]}`}
                errorStatus={errorStatus}
                successMessage={t('validation.perfect')}
                onBlur={() => {
                    setIsFocus(false);
                    setFieldTouched(field);
                    setIsTouchedLocal(true);
                }}
                successStatus={!errors[field] && Boolean(touched[field]) && isTouchedLocal}
                onClear={() => setFieldValue(field, '')}
                className={className}
                onFocus={handleFocus}
                leftIcon={leftIcon}
                rightIcon={rightIcon}
                ref={innerRef}
                onChange={(e) => setFieldValue(field, e.target.value)}
                dataLocator={dataLocator}
                isFocus={isFocus}
            />
        </S.StyledWrapper>
    );
};

export default FormikInput;
